/* ============================================
   SEEK KEY — GA4 Enhanced Ecommerce DataLayer
   ============================================

   v4 (23/03/2026):
   - Fix: item_name e item_category agora populados corretamente
   - Fix: item_variant usa public_title (campo correto do meta.product)
   - Fix: add_to_cart disparava 2x (submit + fetch), agora usa flag de dedup
   - Add: item_category (product.type), item_brand (product.vendor)
   - Add: item_sku no custom dimensions

   v5 (16/10/2026, Q-432):
   - Add: item_product_id / item_variant_id da variante ÂNCORA do feed do
     Merchant (regra Q-163) em view_item e add_to_cart, pro container server
     montar o offerId (shopify_ZZ_<p>_<v>) do remarketing dinâmico e do
     cart data. item_id continua o SKU (GA4/Meta/TikTok inalterados).

   Eventos: page_view, view_item, add_to_cart
   Formato: GA4 Enhanced Ecommerce
   ============================================ */

(function() {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  // ══════════════════════════════════════
  // HELPERS
  // ══════════════════════════════════════

  /* Shopify exposes product data in the global `meta` object on product pages.
     Fields available: id, vendor, type, handle, variants[{id, price, name, public_title, sku}]
     NOTE: meta.product does NOT have a `title` field — use variants[].name or parse from document.title */
  function getShopifyProduct() {
    if (typeof meta !== 'undefined' && meta && meta.product) {
      return meta.product;
    }
    return null;
  }

  function formatPrice(cents) {
    if (typeof cents === 'number') return cents / 100;
    var num = parseFloat(cents);
    return isNaN(num) ? 0 : num;
  }

  /* Extract product title: meta.product has no `title` field.
     Best source is variant.name (e.g. "Abiotic Factor Midia Digital - Steam").
     Fallback: parse document.title removing the store suffix. */
  function getProductTitle(product) {
    if (product && product.variants && product.variants.length > 0) {
      var variantName = product.variants[0].name || '';
      // variant.name often includes " - VariantTitle", strip it for item_name
      if (product.variants.length === 1 && product.variants[0].public_title) {
        var suffix = ' - ' + product.variants[0].public_title;
        if (variantName.endsWith(suffix)) {
          return variantName.slice(0, -suffix.length);
        }
      }
      return variantName;
    }
    // Fallback: document.title minus store name
    var title = document.title || '';
    var separators = [' \u2013 ', ' | ', ' - ', ' \u2014 '];
    for (var i = 0; i < separators.length; i++) {
      var idx = title.indexOf(separators[i]);
      if (idx > 0) return title.substring(0, idx).trim();
    }
    return title;
  }

  function getPageType() {
    var body = document.body;
    if (!body) return 'other';
    var cls = body.className || '';
    if (cls.indexOf('template-product') !== -1) return 'product';
    if (cls.indexOf('template-collection') !== -1) return 'collection';
    if (cls.indexOf('template-cart') !== -1) return 'cart';
    if (cls.indexOf('template-index') !== -1) return 'home';
    if (cls.indexOf('template-search') !== -1) return 'search';
    return 'other';
  }

  function findVariant(product, variantId) {
    if (!product || !product.variants) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === String(variantId)) {
        return product.variants[i];
      }
    }
    return null;
  }

  function normalizePlatform(type) {
    if (!type) return '';
    var t = type.replace(/^Conta\s+/i, '');
    if (/psn|playstation|ps[0-9]/i.test(t)) return 'PlayStation';
    if (/xbox/i.test(t)) return 'Xbox';
    if (/steam/i.test(t)) return 'Steam';
    return t;
  }

  // ══════════════════════════════════════
  // OFFER ID DO MERCHANT CENTER (remarketing dinâmico / cart data)
  // ══════════════════════════════════════
  /* O feed do Merchant (Q-163) usa offerId = shopify_ZZ_<produto>_<variante ÂNCORA>,
     onde âncora = a PRIMÁRIA daquela geração (PS5/PS4), ou a variante 'Steam'.
     Vender a secundária/aluguel não muda o anúncio: o jogo+geração é o mesmo.
     Aqui só mandamos item_product_id/item_variant_id da âncora; quem monta o
     offerId é o container server (transformation), escopado nas tags Google Ads.
     item_id NÃO muda (GA4, Meta e TikTok dependem dele).
     Espelho de portal/services/googleFeed.js (productGenerations, variantGenerations,
     anchorVariant, filtro de famílias e dedupe de âncora). Mudou lá, muda aqui.
     Qualquer dúvida devolve null e o item segue só com o SKU (sem casar, sem quebrar). */
  function skNormLabel(s) {
    s = String(s == null ? '' : s);
    try { s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (_) {}
    return s.toLowerCase().replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
  }
  function skIsAluguel(l) { return skNormLabel(l).indexOf('aluguel') === 0; }
  function skIsSecundaria(l) { return !skIsAluguel(l) && skNormLabel(l).indexOf('secundaria') !== -1; }
  function skIsPrimaria(l) { return skNormLabel(l).indexOf('primaria') !== -1; }
  function skVarLabel(v) { return v ? (v.public_title || v.title || '') : ''; }

  function skVariantGens(label, gens) {
    var n = skNormLabel(label);
    var p5 = /ps5/.test(n), p4 = /ps4/.test(n);
    if (p5 && p4) return gens.slice();
    if (p5) return ['PS5'];
    if (p4) return ['PS4'];
    return gens.slice();
  }

  function skById(list) {
    return list.slice().sort(function(a, b) { return Number(a.id) - Number(b.id); });
  }

  function merchantIds(product, variant) {
    try {
      if (!product || !variant || !product.id || !product.variants || !product.variants.length) return null;
      var tipo = skNormLabel(product.type);
      var plat = tipo === 'playstation' ? 'psn' : (tipo === 'steam' ? 'steam' : null);
      if (!plat) return null;

      var all = product.variants, i;
      var elig = [];
      for (i = 0; i < all.length; i++) {
        var lb = skVarLabel(all[i]);
        var ok = plat === 'steam'
          ? skNormLabel(lb) === 'steam'
          : (skIsPrimaria(lb) || skIsSecundaria(lb) || skIsAluguel(lb));
        if (ok) elig.push(all[i]);
      }
      var vOk = false;
      for (i = 0; i < elig.length; i++) if (String(elig[i].id) === String(variant.id)) vOk = true;
      if (!vOk) return null;

      var gens = [];
      if (plat === 'steam') {
        gens = ['STEAM'];
      } else {
        var p5 = false, p4 = false;
        for (i = 0; i < all.length; i++) {
          var l2 = skVarLabel(all[i]);
          if (!skIsPrimaria(l2)) continue;
          if (/ps5/.test(skNormLabel(l2))) p5 = true;
          if (/ps4/.test(skNormLabel(l2))) p4 = true;
        }
        if (p5) gens.push('PS5');
        if (p4) gens.push('PS4');
        if (!gens.length) gens.push('PS5');
      }

      // âncora por geração, na MESMA ordem e com o MESMO dedupe do feed
      var anchorByGen = {}, used = {};
      for (var g = 0; g < gens.length; g++) {
        var gen = gens[g], cand = [];
        for (i = 0; i < elig.length; i++) {
          if (gen === 'STEAM' || skVariantGens(skVarLabel(elig[i]), gens).indexOf(gen) !== -1) cand.push(elig[i]);
        }
        if (!cand.length) continue;
        var prim = [];
        for (i = 0; i < cand.length; i++) {
          var l3 = skVarLabel(cand[i]);
          if (!skIsPrimaria(l3)) continue;
          if (gen === 'STEAM' || new RegExp(gen, 'i').test(skNormLabel(l3))) prim.push(cand[i]);
        }
        var anc = prim.length ? skById(prim)[0] : skById(cand)[0];
        if (!anc || used[String(anc.id)]) continue;
        used[String(anc.id)] = true;
        anchorByGen[gen] = anc;
      }

      // geração da variante vista/adicionada: a primeira (ordem do feed) que ela serve e que tem oferta
      var vGens = plat === 'steam' ? ['STEAM'] : skVariantGens(skVarLabel(variant), gens);
      for (g = 0; g < gens.length; g++) {
        if (vGens.indexOf(gens[g]) === -1 || !anchorByGen[gens[g]]) continue;
        var pid = String(product.id), vid = String(anchorByGen[gens[g]].id);
        if (!/^\d{10,}$/.test(pid) || !/^\d{10,}$/.test(vid)) return null;
        return { pid: pid, vid: vid };
      }
      return null;
    } catch (_) {
      return null;
    }
  }

  function buildItem(product, variant) {
    var title = getProductTitle(product);
    var price = variant ? formatPrice(variant.price) : 0;
    var item = {
      item_id: variant && variant.sku ? variant.sku : (product ? String(product.id) : ''),
      item_name: title,
      item_category: normalizePlatform(product && product.type ? product.type : ''),
      item_brand: product && product.vendor ? product.vendor : '',
      item_variant: variant && variant.public_title ? variant.public_title : '',
      price: price,
      quantity: 1
    };
    // Q-432: par só sai INTEIRO (os dois ids) ou não sai; meio par fabricaria offerId falso.
    var gmc = merchantIds(product, variant);
    if (gmc) {
      item.item_product_id = gmc.pid;
      item.item_variant_id = gmc.vid;
    }
    return item;
  }

  // ══════════════════════════════════════
  // PAGE VIEW
  // ══════════════════════════════════════
  function pushPageView() {
    window.dataLayer.push({
      event: 'page_view',
      page_type: getPageType(),
      page_title: document.title,
      page_location: window.location.href,
      page_path: window.location.pathname
    });
  }

  // ══════════════════════════════════════
  // VIEW ITEM (product page only)
  // ══════════════════════════════════════
  function pushViewItem() {
    var product = getShopifyProduct();
    if (!product) return;

    var variant = product.variants && product.variants.length > 0 ? product.variants[0] : null;
    var item = buildItem(product, variant);

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'view_item',
      ecommerce: {
        currency: 'BRL',
        value: item.price,
        items: [item]
      }
    });
  }

  // ══════════════════════════════════════
  // ADD TO CART
  // ══════════════════════════════════════
  var lastAddToCartTime = 0;

  function pushAddToCart(variantId, quantity) {
    // Dedup: prevent double-firing from submit + fetch intercept
    var now = Date.now();
    if (now - lastAddToCartTime < 1000) return;
    lastAddToCartTime = now;

    var product = getShopifyProduct();
    var variant = product ? findVariant(product, variantId) : null;
    var item = buildItem(product, variant);
    item.quantity = quantity || 1;

    // If no product in meta (e.g. quick-add from collection page), use fallbacks
    if (!item.item_name) {
      item.item_name = document.title.split(' \u2013 ')[0] || document.title.split(' | ')[0] || '';
    }

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: 'BRL',
        value: item.price * item.quantity,
        items: [item]
      }
    });
  }

  // ══════════════════════════════════════
  // INTERCEPT ADD-TO-CART
  // ══════════════════════════════════════
  function interceptAddToCart() {
    // Intercept form submissions to /cart/add
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;

      var variantInput = form.querySelector('input[name="id"], select[name="id"]');
      var qtyInput = form.querySelector('input[name="quantity"]');
      var variantId = variantInput ? variantInput.value : null;
      var qty = (qtyInput && parseInt(qtyInput.value)) || 1;

      if (variantId) pushAddToCart(variantId, qty);
    });

    // Intercept fetch calls to /cart/add (for AJAX add-to-cart)
    if (window.fetch) {
      var originalFetch = window.fetch;
      window.fetch = function() {
        var url = arguments[0];
        var opts = arguments[1] || {};

        if (typeof url === 'string' && url.indexOf('/cart/add') !== -1 && opts.body) {
          try {
            var body;
            if (typeof opts.body === 'string') {
              body = JSON.parse(opts.body);
            } else if (opts.body instanceof FormData) {
              body = { id: opts.body.get('id'), quantity: opts.body.get('quantity') };
            }
            if (body && body.id) {
              pushAddToCart(body.id, parseInt(body.quantity) || 1);
            }
          } catch (_) {}
        }
        return originalFetch.apply(this, arguments);
      };
    }
  }

  // ══════════════════════════════════════
  // INIT
  // ══════════════════════════════════════
  function init() {
    pushPageView();

    if (getPageType() === 'product') {
      pushViewItem();
    }

    interceptAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
